import { schema } from 'normalizr';

export const creditBand = new schema.Entity('creditBands');
export const creditBands = [creditBand];
